
import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";

/* ---------------- MAIN SLIDER SETTINGS ---------------- */
const SliderSettings = {
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: false,
  pauseOnHover: true,
  autoplaySpeed: 4000,
  speed: 5000,
  cssEase: "ease",
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: false,
  prevArrow: (
    <button className="slick-arrow slick-prev" aria-label="Previous Slide">
      <i className="fa-solid fa-arrow-left"></i>
    </button>
  ),
  nextArrow: (
    <button className="slick-arrow slick-next" aria-label="Next Slide">
      <i className="fa-solid fa-arrow-right"></i>
    </button>
  ),
  responsive: [
    { breakpoint: 1050, settings: { slidesToShow: 3 } },
    { breakpoint: 991, settings: { slidesToShow: 2 } },
    { breakpoint: 768, settings: { slidesToShow: 1 } },
  ],
};

/* ---------------- BRAND SLIDER SETTINGS ---------------- */
const getBrandSliderSettings = (length) => ({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  cssEase: "linear",
  slidesToShow: Math.min(3, length),
  slidesToScroll: 1,
  pauseOnHover: false,
  pauseOnFocus: false,
  swipe: false,
});



export default function HomeProducts({ data, extraClass = "", initialData }) {
  const sectionRef = useRef(null);
  const mainSliderRef = useRef(null);
  const brandSliderRefs = useRef([]);
  const [allData, setAllData] = useState(initialData || []);

  useEffect(() => {
    let autoplayTimer;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!mainSliderRef.current) return;

        if (entry.isIntersecting) {
          // 🔹 reset to first slide
          mainSliderRef.current.slickPause();
          mainSliderRef.current.slickGoTo(0, true);

          // 🔹 start autoplay after 5 sec
          autoplayTimer = setTimeout(() => {
            mainSliderRef.current?.slickPlay();
          }, 5000);
        } else {
          mainSliderRef.current.slickPause();
          clearTimeout(autoplayTimer);
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      observer.disconnect();
      clearTimeout(autoplayTimer);
    };
  }, []);


  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/product-categories`, {
        method: 'GET',
      });

      const result = await response.json();
      if (result.product_categories === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.product_categories);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    fetcher();
  }, [])



  return (
    <section className={`products-section ${extraClass}`} ref={sectionRef}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-10">
            {data?.title && (
              <div className="choose-text center-heading">
                {data.subtitle && <span className="gradient-color">{data.subtitle}</span>}
                {data.title && <h3 className="heading" dangerouslySetInnerHTML={{ __html: data.title }} />}
              </div>
            )}
          </div>
        </div>

        <div className="products-wrapper">
          <Slider {...SliderSettings} className="product-cards" ref={mainSliderRef}>
            {allData.map((product, i) => (
              <div className="product-card" key={i}>
                <div className="img-box">
                  <img src={product?.category_thumbnail ? `${BaseUrl}${product.category_thumbnail}` : undefined} className="img-responsive" alt={product?.alt_category_thumbnail} />
                </div>
                <div className="heading">{product?.name}</div>
                <p>{product?.brief}</p>
                <div className="brand-sliders">
                  <Slider    {...getBrandSliderSettings(product.logos.length)} ref={(el) => (brandSliderRefs.current[i] = el)} className="brand-logo-slider" >
                    {product.logos.map((logo, index) => (
                      <div className="logos" key={index}>
                        {logo?.image?.trim() && (
                          <div className="brand-sliders-inner">
                            <img src={`${BaseUrl}${logo.image}`} className="img-responsive" alt={logo?.alt_image || "Brand Logo"} />
                          </div>
                        )}
                      </div>
                    ))}
                  </Slider>
                </div>
                <Link to={`/product-listing/${product?.slug}`} className="default-btn">
                  <span >{product?.button_text} </span>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
